import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function getSessionId() {
    try {
        const p = new URLSearchParams(window.location.search).get("sid");
        if (p && p !== "null" && p !== "undefined") {
            localStorage.setItem("revanche_session_id", p);
            return p;
        }
    } catch (e) {}
    const s = localStorage.getItem("revanche_session_id");
    return (s && s !== "null" && s !== "undefined") ? s : null;
}

export async function saveAnswers(answers, step) {
    const sid = getSessionId();
    if (!sid) return null;
    const body = { answers };
    if (step != null) body.step = step;
    const { data } = await axios.patch(`${API}/session/${sid}/answers`, body);
    return data;
}

export async function completeQuestionnaire(answers) {
    const sid = getSessionId();
    if (!sid) return null;
    const { data } = await axios.post(
        `${API}/session/${sid}/complete-questionnaire`,
        { answers },
    );
    return data;
}

export async function fetchSession() {
    const sid = getSessionId();
    if (!sid) return null;
    try {
        const { data } = await axios.get(`${API}/session/${sid}`);
        return data;
    } catch (e) {
        return null;
    }
}
